<template>
    <div class="col-lg-12">
        <table-search-and-pagination
            hide-per-page
            :table-data="quotes"
            @dataUpdated="queriedData = $event"
        >
            <div slot="header">
                <div class="flex-end">
                    <base-button
                        v-if="showNewQuoteRequestButton"
                        type="primary"
                        @click="$emit('update:showNewQuoteRequestModal', true)"
                    >
                        New Quote Request
                    </base-button>
                </div>
            </div>
            <quotes-table
                v-if="quotes.length > 0"
                :quotes="queriedData"
                :exclude-columns="excludedColumns"
                @rowClicked="$emit('quoteRowClicked', $event)"
            />
        </table-search-and-pagination>
        <quote-detail
            v-if="showQuoteSummary"
            :quote="selectedQuote"
            :show="showQuoteSummary"
            @update:show="$emit('update:showQuoteSummary', $event)"
        />
        <new-quote
            v-if="showNewQuoteRequestModal"
            :show="showNewQuoteRequestModal"
            @update:show="$emit('update:showNewQuoteRequestModal', $event)"
        />
    </div>
</template>

<script>
import TableSearchAndPagination from "src/components/TableSearchAndPagination";
import NewQuote from "src/modules/Quote/NewQuote";
import QuoteDetail from "src/modules/Quote/QuoteDetail";
import QuotesTable from "./QuotesTable";

export default {
    name: "Quotes",
    components: {
        QuoteDetail,
        QuotesTable,
        NewQuote,
        TableSearchAndPagination,
    },
    props: {
        excludedColumns: {
            type: Array,
            default: () => [],
        },
        quotes: {
            type: Array,
            default: () => [],
        },
        showQuoteSummary: {
            type: Boolean,
            required: true,
        },
        showNewQuoteRequestModal: {
            type: Boolean,
            required: true,
        },
        showNewQuoteRequestButton: {
            type: Boolean,
            required: true,
        },
        selectedQuote: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            queriedData: [],
        };
    },
};
</script>
